import {
  LoadingIndicator,
  SkeletonView,
  useThemeProvider,
} from "@towersystems/roam-common-native";
import { StyleSheet, View } from "react-native";

type LoadingImageTileProps = {
  width: number;
  height: number;
  margin: number;
};

export function LoadingImageTile({
  width,
  height,
  margin,
}: LoadingImageTileProps) {
  const { colors, spacings } = useThemeProvider();

  return (
    <SkeletonView
      style={[
        styles.button,
        {
          margin,
          height,
          width,
          borderColor: colors.borderColor,
          borderRadius: spacings.s4,
          backgroundColor: colors.surface,
        },
      ]}
      height={height}
      width={width}
    />
  );
}

const styles = StyleSheet.create({
  button: {
    borderWidth: 2,
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
});
